import { io, type Socket } from 'socket.io-client';

const BASE_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? '';

/**
 * Conexão em tempo real com a API. O token vai no handshake — cabeçalhos não
 * existem no WebSocket e query string ficaria registrada em log de acesso.
 */
export function createSocket(token: string): Socket {
  return io(BASE_URL || window.location.origin, {
    path: '/realtime',
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10_000,
  });
}
